import React, { useEffect, useRef } from 'react';
import { Field } from 'redux-form';
import { M } from '@dashboard-experience/mastodon';
import { i18n } from '@international/mastodon-i18n';
import { Checkbox } from '../fields';

const PREFIX =
  'components.Report.Verification.MatrixVerification.DrivingExperience.enhanced.noHistory';

// Checkbox renders its error via <T value={error} />, which expects a
// translation key. Return the key itself, not i18n.getStr's resolved string.
const validateConfirmed = (value?: string) =>
  value ? undefined : `${PREFIX}.error.required`;

const normalizeConfirmed = (checked?: boolean) =>
  checked ? 'true' : undefined;

export interface DrivingExperienceNoHistoryProps {
  fieldKey: string;
  company: string;
}

const DrivingExperienceNoHistory = ({
  fieldKey,
  company,
}: DrivingExperienceNoHistoryProps) => {
  const titleRef = useRef<HTMLHeadingElement>(null);

  // The panel replaces the link that opened it, so move focus here instead of losing it.
  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  return (
    <section className='dee-no-history' data-testid='dee-no-history'>
      <h3 className='dee-no-history__title' ref={titleRef} tabIndex={-1}>
        {i18n.getStr(`${PREFIX}.title`)}
      </h3>

      <M.InlineNotification
        kind='warning'
        title={i18n.getStr(`${PREFIX}.warning.title`)}
        subtitle={i18n.getStr(`${PREFIX}.warning.body`, { company })}
        className='dee-no-history__warning'
        hideCloseButton
      />

      <p className='dee-no-history__intro'>
        {i18n.getStr(`${PREFIX}.consequence`, { company })}
      </p>

      <Field
        type='checkbox'
        name={fieldKey}
        label={`${PREFIX}.confirm`}
        className='dee-no-history__checkbox'
        component={Checkbox}
        validate={validateConfirmed}
        normalize={normalizeConfirmed}
        i18n
      />
    </section>
  );
};

export default i18n.renderTranslation()(DrivingExperienceNoHistory);
